/*
 * Bespoke stories — carousel arrows, card turn, and ENQUIRE -> form.
 * Markup: sections/bespoke-stories.liquid. Styles: assets/bespoke-page.css.
 *
 * The track is a native scroll container with scroll-snap, so swipe, trackpad
 * and keyboard scrolling all work without this script; the arrows are only an
 * addition, and are hidden when every card already fits on screen.
 */
(function () {
  'use strict';

  function initStories(root) {
    var track = root.querySelector('[data-stories-track]');
    var nav = root.querySelector('[data-stories-nav]');
    var prev = root.querySelector('[data-stories-prev]');
    var next = root.querySelector('[data-stories-next]');
    if (!track) return;

    function step() {
      var card = track.querySelector('[data-story-card]');
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function updateNav() {
      var overflow = track.scrollWidth > track.clientWidth + 4;
      if (nav) nav.hidden = !overflow;
      if (!overflow) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(updateNav); }, { passive: true });
    window.addEventListener('resize', updateNav);
    updateNav();

    // ---- turning a card ----------------------------------------------------
    function setFlipped(card, on) {
      card.classList.toggle('is-flipped', on);
      var open = card.querySelector('[data-story-open]');
      var back = card.querySelector('[data-story-back]');
      if (open) open.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (back) back.setAttribute('aria-hidden', on ? 'false' : 'true');
    }

    root.querySelectorAll('[data-story-card]').forEach(function (card) {
      var open = card.querySelector('[data-story-open]');
      var close = card.querySelector('[data-story-close]');

      if (open) open.addEventListener('click', function () {
        // One story open at a time reads more calmly than a row of dark panels.
        root.querySelectorAll('[data-story-card].is-flipped').forEach(function (c) {
          if (c !== card) setFlipped(c, false);
        });
        setFlipped(card, true);
        if (close) close.focus({ preventScroll: true });
      });

      if (close) close.addEventListener('click', function () {
        setFlipped(card, false);
        if (open) open.focus({ preventScroll: true });
      });

      // Hover turns the card on devices with a mouse. Touch is left to the
      // DISCOVER tap, since a touch screen has no hover to leave again.
      // The short delay stops the dark panel flashing on every card when the
      // pointer merely sweeps across the row on its way somewhere else.
      var hoverTimer = null;
      card.addEventListener('pointerenter', function (e) {
        if (e.pointerType !== 'mouse') return;
        window.clearTimeout(hoverTimer);
        hoverTimer = window.setTimeout(function () {
          root.querySelectorAll('[data-story-card].is-flipped').forEach(function (c) {
            if (c !== card) setFlipped(c, false);
          });
          setFlipped(card, true);
        }, 120);
      });
      card.addEventListener('pointerleave', function (e) {
        if (e.pointerType !== 'mouse') return;
        window.clearTimeout(hoverTimer);
        // Keep it open if keyboard focus is inside, so tabbing to ENQUIRE and
        // then nudging the mouse does not snatch the panel away.
        if (card.contains(document.activeElement) && document.activeElement !== open) return;
        setFlipped(card, false);
      });
    });

    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var card = e.target.closest && e.target.closest('[data-story-card].is-flipped');
      if (!card) return;
      setFlipped(card, false);
      var open = card.querySelector('[data-story-open]');
      if (open) open.focus({ preventScroll: true });
    });

    // ---- ENQUIRE: carry the story up into the form -------------------------
    root.querySelectorAll('[data-story-enquire]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var form = document.getElementById('bespoke-form');
        var message = form && form.querySelector('[data-bespoke-message]');
        if (!form || !message) return; // no form on this page: let the link act normally
        e.preventDefault();

        var title = link.getAttribute('data-story-title') || '';
        var intro = title ? 'I am inspired by "' + title + '" and would love to create something of my own.\n\n' : '';

        // Only prefill an empty box, or one that still holds a previous prefill,
        // so nothing a visitor has already written is ever overwritten.
        var current = message.value;
        if (!current.trim() || /^I am inspired by "[^"]*" and would love to create something of my own\.\n\n$/.test(current)) {
          message.value = intro;
        }

        form.scrollIntoView({ behavior: 'smooth', block: 'start' });
        window.setTimeout(function () {
          message.focus({ preventScroll: true });
          var end = message.value.length;
          try { message.setSelectionRange(end, end); } catch (err) {}
        }, 500);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-bespoke-stories]').forEach(initStories);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  // Re-initialise when the section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-bespoke-stories]');
    if (el) initStories(el);
  });
})();
